import React from 'react';
import Slider from 'react-slick';

const MainSlider = (props) => {
	const sliderRef = React.useRef(null);

	const PrevArrow = () => (
		<button className="prev" onClick={() => sliderRef?.current?.slickPrev()}>
			<ion-icon name="chevron-back-outline"></ion-icon>
		</button>
	);

	const NextArrow = () => (
		<button className="next" onClick={() => sliderRef?.current?.slickNext()}>
			<ion-icon name="chevron-forward-outline"></ion-icon>
		</button>
	);

	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
	};

	return (
		<div className="main-carousel">
			<div className="carousel-arrows">
				<PrevArrow />
				<NextArrow />
			</div>

			<Slider ref={sliderRef} {...settings}>
				{['sabah-sporu', '', 'yakin-markaj', 'ters-kose', 'spor-kazani'].map((slide, i) => (
					<div key={i}>
						<div className={`carousel-image${slide !== '' ? ' podcast-slider' : ''}`}>
							<img src={`/assets/images/${slide !== '' ? slide + '.webp' : 'carousel-1.png'}`} alt="" />
						</div>

						{slide === '' && (
							<div className="carousel-inner">
								<div className="container">
									<div className="carousel-title">
										Radyospor, <br /> Sporun Tek Adresi...
									</div>

									<div className="carousel-subtitle">
										<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque tincidunt consectetur dolor, ut tincidunt nunc varius vel.</p>
									</div>

									<div className="carousel-button">
										<a href="#!">Podcastlere Git</a>
									</div>
								</div>
							</div>
						)}
					</div>
				))}
			</Slider>
		</div>
	);
};

export default MainSlider;
